import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["src"]

import { computed } from "vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BrightcoveVideo',
  props: {
        accountId: { type: String, required: true },
        videoId: { type: String, required: true },
        ariaLabel: { type: String, required: true }
    },
  setup(__props) {

    const props = __props;

    const videoSrc = computed(() => {
        return `https://players.brightcove.net/${props.accountId}/default_default/index.html?videoId=${props.videoId}`;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "container",
    role: "region",
    "aria-label": __props.ariaLabel,
    class: "brightcove-video-container"
  }, [
    _createElementVNode("iframe", {
      src: videoSrc.value,
      class: "w-100",
      allowfullscreen: "",
      allow: "encrypted-media",
      frameborder: "0"
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})